module.exports = __webpack_public_path__ + "img/ites.cda552a4.jpg";